import * as React from "react";

const SVGComponent = (props) => (
  <svg
    width={172}
    height={202}
    viewBox="0 0 172 202"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0)">
      <path
        d="M0.100098 0H171.1V201.5H0.100098V0Z"
        fill="white"
        fillOpacity={0.01}
      />
      <path
        d="M46.2891 10.4251C47.6371 10.7165 48.8141 11.5315 49.5612 12.6907C50.3082 13.85 50.5642 15.2585 50.2728 16.6065L10.2901 201.534L0.125001 199.336L40.1077 14.4087C40.3991 13.0608 41.2141 11.8838 42.3733 11.1367C43.5326 10.3896 44.9411 10.1336 46.2891 10.4251Z"
        fill="#FFC400"
      />
      <path
        d="M147.1 52.4996L128.3 139.4C128.919 135.813 128.117 132.125 126.064 129.12C124.01 126.114 120.867 124.027 117.3 123.3L21.1001 102.5L39.9001 15.5996L136.1 36.3996C139.667 37.1266 142.81 39.2142 144.864 42.2197C146.917 45.2253 147.719 48.9126 147.1 52.4996Z"
        fill="url(#paint0_linear)"
      />
      <path
        d="M171.1 98.3988L152.4 185.099L77.5001 168.999C74.1703 168.267 71.2613 166.255 69.4001 163.399C68.463 161.986 67.8206 160.399 67.5113 158.732C67.202 157.066 67.2322 155.354 67.6001 153.699C69.1001 146.599 76.3001 142.399 83.4001 143.899L112 150.099C113.774 150.479 115.605 150.502 117.388 150.169C119.171 149.835 120.87 149.151 122.386 148.155C123.903 147.16 125.206 145.873 126.221 144.37C127.237 142.867 127.943 141.177 128.3 139.399L138.7 91.3988C138.7 91.3723 138.711 91.3469 138.729 91.3281C138.748 91.3094 138.774 91.2988 138.8 91.2988L171.1 98.3988Z"
        fill="url(#paint1_linear)"
      />
      <path
        d="M128.3 139.4C127.943 141.179 127.236 142.869 126.221 144.372C125.206 145.875 123.903 147.161 122.386 148.157C120.87 149.152 119.171 149.837 117.388 150.17C115.605 150.504 113.774 150.48 112 150.1L82.9001 143.8C79.5587 143.088 76.0712 143.73 73.2029 145.586C70.3345 147.442 68.3196 150.361 67.6001 153.7L76.1001 114.4L117.3 123.3C120.867 124.027 124.01 126.115 126.064 129.121C128.117 132.126 128.919 135.813 128.3 139.4Z"
        fill="#0049B0"
      />
      <path
        d="M47.4001 10.6C50.3272 10.6 52.7001 8.22711 52.7001 5.3C52.7001 2.37289 50.3272 0 47.4001 0C44.473 0 42.1001 2.37289 42.1001 5.3C42.1001 8.22711 44.473 10.6 47.4001 10.6Z"
        fill="#FF991F"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear"
        x1={28.2014}
        y1={113.474}
        x2={143.095}
        y2={39.4219}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0065FF" />
        <stop offset={1} stopColor="#2684FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1={67.2901}
        y1={138.209}
        x2={171.14}
        y2={138.209}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0052CC" />
        <stop offset={1} stopColor="#0065FF" />
      </linearGradient>
      <clipPath id="clip0">
        <path d="M0.100098 0H171.1V201.5H0.100098V0Z" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SVGComponent;



// WEBPACK FOOTER //
// ./src/components/svg/NotificationFlagIcon.js